'use client';

import type React from 'react';
import cx from 'classnames';
import Link from 'next/link';
import { getRouteHref, ROUTES } from '@/forApp/utils/routes';

import styles from './styles.module.css';

interface AttenCardProps {
  card: {
    title: string;
    slug: string;
    preview_image_path: string;
    preview_text: string;
  };
}

const AttenCard: React.FC<AttenCardProps> = ({ card }) => {
  if (!card) {
    return null;
  }
  return (
    <Link
      href={getRouteHref(ROUTES.SERVICES_ITEM, { slug: card.slug })}
      className={cx(styles.wrapper, styles.card)}
    >
      <div className={styles.header}>
        <div className={styles.headerImg}>
          <img src={card.preview_image_path} alt={card.title} />
        </div>
      </div>
      <h2 className={styles.title}>{card.title}</h2>
      <div className={styles.text}>{card.preview_text}</div>
    </Link>
  );
};

export default AttenCard;
